import React from 'react';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { RubricRoleOperation } from 'libs/end-to-end/src/types/rubrics/rubric';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { EditRubricEditButton } from 'apps/sigma2-ui/src/components/rubrics/EditRubricEditButton';
import { EditRubricRemoveButton } from 'apps/sigma2-ui/src/components/rubrics/EditRubricRemoveButton';

interface EditRubricRoleRulePreviewProps {
  operation: RubricRoleOperation;
  name: string;
  onEdit: () => void;
  onRemove: () => void;
  isReadOnlyMode: boolean;
}

export const EditRubricRoleRulePreview: React.FC<
  EditRubricRoleRulePreviewProps
> = ({ operation, name, onEdit, onRemove, isReadOnlyMode }) => {
  const language = useLanguage();

  return (
    <Spacing
      direction="horizontal"
      size="sm"
      className="rounded-lg bg-indigo-100 px-5 py-4 justify-between flex group"
    >
      <Spacing direction="horizontal" size="gap-9" className="items-center">
        <S2Typography
          variant="body-6-medium"
          textColorVariant="indigo-1000"
          translatedContent={language.rubricRoleOperationDisplay({ operation })}
        />
        <S2Typography
          variant="body-6-bold"
          textColorVariant="indigo-1000"
          translatedContent={name}
        />
      </Spacing>
      {!isReadOnlyMode && (
        <Spacing
          direction="horizontal"
          size="md"
          className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 ease-in-out"
        >
          <EditRubricEditButton
            behavior={{
              type: 'onClick',
              onClick: onEdit,
            }}
          />
          <EditRubricRemoveButton
            behavior={{
              type: 'onClick',
              onClick: onRemove,
            }}
          />
        </Spacing>
      )}
    </Spacing>
  );
};
